module.exports = __webpack_public_path__ + "img/bitbox.3854fbba.svg";